import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext } from '../../contexts';
import { ComuneCompetenzaContext, ComuneCompetenzaProvider } from './ComuneCompetenzaContext';
import { AddEccezioneDialog, ComuneCompetenzaForm, EccezioniList, StoricoList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        replaceBreadcrumbToken,
        setBread,
        goBack
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingUfficioComuneCompetenza,
        getUfficioComuneCompetenzaAsync,

        isUpdatingUfficioComuneCompetenza,
        updateUfficioComuneCompetenzaAsync,

        isAddingUfficioComuneCompetenza,
        addUfficioComuneCompetenzaAsync,

        isLoadingTipiUffici,
        getTipiUfficiAsync,

        isLoadingCompetenze,
        getCompetenzeAsync,

        isLoadingUffici,
        getUfficiAsync,

        isLoadingEccezioni,
        getEccezioniAsync,

        isAddingEccezione,
        addEccezioneAsync,

        isDeletingEccezione,
        deleteEccezioneAsync,

        isLoadingStorici,
        getStoriciAsync,

    } = useContext(ComuneCompetenzaContext)

    const {
        ufficioComuneCompetenza,
        tipiUffici,
        eccezioni,
    } = state;

    const {
        comuneId,
        competenzaId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingUfficioComuneCompetenza || isUpdatingUfficioComuneCompetenza || isAddingUfficioComuneCompetenza || isLoadingUffici);
    }, [isLoadingUfficioComuneCompetenza, isUpdatingUfficioComuneCompetenza, isAddingUfficioComuneCompetenza, isLoadingUffici])

    const comuneCompetenzaFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (ufficioComuneCompetenza) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateUfficioComuneCompetenzaAsync(comuneId, data.competenzaId, { id: ufficioComuneCompetenza.id, ...data });
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addUfficioComuneCompetenzaAsync(comuneId, competenzaId, data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const [openAddEccezioneDialog, setOpenAddEccezioneDialog] = React.useState(false);

    const loadMoreHandler = async (pageIndex, pageSize) => {
        await getEccezioniAsync(comuneId, competenzaId, pageIndex, pageSize);
    }

    const eccezioniListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                setOpenAddEccezioneDialog(true);
                break;
            case "Delete":
                await deleteEccezioneAsync(comuneId, competenzaId, data.id);
                break;
            default:
                break;
        }
    }

    const addEccezioneDialogActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                setOpenAddEccezioneDialog(false);
                await addEccezioneAsync(comuneId, competenzaId, data);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (ufficioComuneCompetenza) {
            addBreadcrumbToken(ufficioComuneCompetenza.competenza.tipoUfficio.nome, window.location.pathname, window.location.pathname);
        }
    }, [ufficioComuneCompetenza]);

    useEffect(() => {
        if (ufficioComuneCompetenza && tipiUffici)
            getUfficiAsync([...getTipiUfficiTreeIds(tipiUffici.result, ufficioComuneCompetenza.competenza.tipoUfficioId), ufficioComuneCompetenza.competenza.tipoUfficioId]);
    }, [ufficioComuneCompetenza, tipiUffici])

    const getTipiUfficiTreeIds = (tipi, padreId) => {
        let result = [];
        let ids = tipi.filter(x => x.padreId == padreId).map(x => x.id);
        ids.forEach(id => {
            result = [...result, ...getTipiUfficiTreeIds(tipi, id), id];
        });
        return result;
    }

    useEffect(() => {
        if (user) {
            getCompetenzeAsync();
            getTipiUfficiAsync();
            if (!competenzaId) {
                addBreadcrumbToken("Aggiungi");
            } else {
                getUfficioComuneCompetenzaAsync(comuneId, competenzaId);
                getEccezioniAsync(comuneId, competenzaId, 0, 25);
                getStoriciAsync(comuneId, competenzaId);
            }
        }
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            save
                            onSaveClick={saveClickHandler}
                            title={`${ufficioComuneCompetenza?.competenza.tipoUfficio.nome}`}
                            subtitle="Gestisci la competenza" />
                    </Grid>
                    <Grid item xs={12} sx={{ paddingTop: 4 }}>
                        <ComuneCompetenzaForm
                            onActionClick={comuneCompetenzaFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef} />
                    </Grid>
                    {
                        ufficioComuneCompetenza &&
                        <Grid item xs={12}>
                            <EccezioniList
                                itemsPerPage={25}
                                onLoadMore={loadMoreHandler}
                                disabled={isLoading}
                                onActionClick={eccezioniListActionClickHandler} />
                        </Grid>
                    }
                    {
                        ufficioComuneCompetenza &&
                        <Grid item xs={12}>
                            <StoricoList
                                disabled={isLoading} />
                        </Grid>
                    }
                </Grid>
                {
                    ufficioComuneCompetenza &&
                    <AddEccezioneDialog
                        open={openAddEccezioneDialog}
                        setOpen={setOpenAddEccezioneDialog}
                        onActionClick={addEccezioneDialogActionClickHandler}
                        disabled={isLoading} />
                }
            </Container>
        </>
    );
}

export const ComuneCompetenzaPage = () => {

    return (
        <ComuneCompetenzaProvider>
            <PageContent />
        </ComuneCompetenzaProvider>
    );
}